import { DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { SharedModule } from "src/app/shared/shared.module";
import { DevolucaoHonraCadastroComponent } from "./cadastro/devolucao-honra-cadastro.component";
import { DevolucaoHonraDetalhesComponent } from "./detalhe/devolucao-detalhe.component";
import { DevolucaoHonraRoutingModule } from "./devolucao-honra-rounting.module";
import { DevolucaoHonraPesquisaComponent } from "./pesquisa/devolucao-honra-pesquisa.component";
import { DevolucaoHonraListagemComponent } from "./pesquisa/listagem/devolucao-honra-listagem.component";

@NgModule({
    declarations:[
        DevolucaoHonraDetalhesComponent,
        DevolucaoHonraCadastroComponent,
        DevolucaoHonraPesquisaComponent,
        DevolucaoHonraListagemComponent,
    ],
    imports:[
        SharedModule,
        ReactiveFormsModule,
        DevolucaoHonraRoutingModule
    ],
    providers:[
        DatePipe
    ]
})
export class DevolucaoHonraModule{}